import { useState } from "react";
import { Mail, Phone, Building2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useSite } from "../lib/store";
import { Markdown, Dots } from "../components/Bits";
import { useSeo } from "../components/Seo";

export default function Contact() {
  const { site } = useSite();
  useSeo({ title: "Kontakt", description: "Napište nám – rádi poradíme s výběrem materiálů pro mateřskou školu, objednávkou i stažením souborů." });
  const [f, setF] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  if (!site) return <div className="h-[60vh]" />;
  const c = site.company;
  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", f);
      toast.success("Zpráva odeslána, brzy se ozveme!");
      setF({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="max-w-7xl mx-auto px-6 py-14 grid lg:grid-cols-2 gap-12" data-testid="contact-page">
      <div className="relative">
        <p className="eyebrow mb-2">Kontakt</p>
        <h1 className="text-4xl sm:text-5xl font-semibold mb-6"><span className="squiggle">Napište nám</span></h1>
        <Markdown text={site.texts.contact_page} />
        <div className="mt-8 space-y-4">
          {[[Building2, `${c.owner} · IČO ${c.ico}`], [Phone, c.phone, `tel:${(c.phone || "").replace(/\s/g, "")}`], [Mail, c.email, `mailto:${c.email}`]].map(([I, t, h]) => (
            <div key={t} className="flex items-center gap-4"><span className="w-12 h-12 rounded-full bg-[var(--pink-soft)] grid place-items-center"><I className="w-5 h-5 text-[var(--pink-dark)]" /></span>{h ? <a href={h} className="font-semibold hover:text-[var(--pink)]">{t}</a> : <span className="font-semibold">{t}</span>}</div>
          ))}
        </div>
      </div>
      <form onSubmit={send} className="relative bg-[var(--blush)] sketch p-8 sm:p-10 space-y-3" data-testid="contact-form">
        <Dots />
        <input data-testid="contact-name-input" required placeholder="Jméno" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="field relative" />
        <input data-testid="contact-email-input" type="email" required placeholder="E-mail" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="field relative" />
        <textarea data-testid="contact-message-input" required rows={6} placeholder="Vaše zpráva…" value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} className="field relative" />
        <button data-testid="contact-submit-btn" disabled={busy} className="btn-pink relative">{busy ? "Odesílám…" : "Odeslat zprávu"}</button>
      </form>
    </div>
  );
}
